import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AppLayout from "./layouts/AppLayout";
import { lazy, Suspense } from "react";
import { Row, Spin } from "antd";
import ErrorHandler from './store/ErrorHandler';
import { ErrorBoundary } from 'react-error-boundary';
import CaseDownPage from "./pages/main/CaseDownPage";

//  router
const PrivateRoute = lazy(() => import('./router/PrivateRoute'));

//  Pages
const LoginPage = lazy(() => import('./pages/auth/LoginPage'));
const ManagerPage = lazy(() => import('./pages/main/ManagerPage'));
const CustomerPage = lazy(() => import('./pages/main/CustomerPage'));
const AuditTrailPage = lazy(() => import('./pages/main/AuditTrailPage'));
const DashBoardPage = lazy(() => import('./pages/main/DashBoardPage'));
//  Error
const NotFoundPage = lazy(() => import('./pages/error/NotFoundPage'));

function App() {
  return (
    <Router>
      <ErrorBoundary FallbackComponent={ErrorHandler} onReset={() => {sessionStorage.clear()}}>
        <Suspense fallback={<Row justify='center' align='middle' style={{minHeight: '100vh'}}><Spin size='large' /></Row>}>
          <Routes>
            <Route element={<AppLayout />}>
              <Route exact path='/' element={<LoginPage />} />
              <Route element={<PrivateRoute />}>
                  <Route exact path='/dashboard' element={<DashBoardPage/>}/>
                  <Route exact path='/manager/:type' element={<ManagerPage/>}/>
                  <Route exact path='/customer/:type' element={<CustomerPage/>}/>
                  <Route exact path='/audit' element={<AuditTrailPage/>}/>
                  <Route exact path='/down' element={<CaseDownPage/>}/>
              </Route>
            </Route>
            <Route path='*' element={<NotFoundPage/>}/>
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
